import { Card, Button } from '../atoms'
import type { POICandidate } from '../../types'

export interface POIHistoryEntry extends POICandidate {
  timestamp: number
  spoken: string
}

export interface POIHistoryProps {
  history: POIHistoryEntry[]
  onClear: () => void
}

export const POIHistory = ({ history, onClear }: POIHistoryProps) => {
  if (history.length === 0) {
    return (
      <Card>
        <div className="text-text-muted text-sm">No POI history yet</div>
      </Card>
    )
  }

  return (
    <Card>
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold">POI History</h3>
        <Button onClick={onClear} variant="secondary" size="sm">
          Clear
        </Button>
      </div>
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {history.slice(0, 20).map((poi) => (
          <div
            key={`${poi.key}-${poi.timestamp}`}
            className="text-sm border-b border-border pb-2 last:border-0"
          >
            <div className="font-medium">{poi.title}</div>
            <div className="text-text-muted text-xs">
              {new Date(poi.timestamp).toLocaleTimeString()} • {poi.source}
            </div>
            {poi.spoken && (
              <div className="text-text-muted text-xs mt-1 line-clamp-2">
                {poi.spoken.slice(0, 100)}...
              </div>
            )}
          </div>
        ))}
      </div>
    </Card>
  )
}
